import { useState } from "react";
import { pInput } from "@/components/admin/proposal/ItemRows";

export const EMPTY_SHIPMENT = { client_name: "", client_phone: "", item: "", tracking_code: "" };

// Dados da entrega (criar ou editar).
export const ShipmentForm = ({ initial = EMPTY_SHIPMENT, busy, submitLabel, onSubmit, onCancel, testid = "shipment-form" }) => {
  const [f, setF] = useState(initial);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const ok = f.client_name.trim() && f.item.trim();
  return (
    <form data-testid={testid} onSubmit={(e) => { e.preventDefault(); if (ok) onSubmit(f); }} className="grid gap-3 sm:grid-cols-2">
      <label className="text-sm text-zinc-300">Nome do cliente
        <input data-testid={`${testid}-name`} value={f.client_name} maxLength={80} onChange={set("client_name")} placeholder="Ex: Ana Paula" className={`${pInput} mt-1.5`} />
      </label>
      <label className="text-sm text-zinc-300">WhatsApp do cliente
        <input data-testid={`${testid}-phone`} inputMode="tel" value={f.client_phone} maxLength={25} onChange={set("client_phone")} placeholder="(35) 99999-9999" className={`${pInput} mt-1.5`} />
      </label>
      <label className="text-sm text-zinc-300">O que vai ser entregue
        <input data-testid={`${testid}-item`} value={f.item} maxLength={200} onChange={set("item")} placeholder="Ex: iPhone 15 Pro Max 256GB" className={`${pInput} mt-1.5`} />
      </label>
      <label className="text-sm text-zinc-300">Código de rastreio dos Correios <span className="text-zinc-400">(opcional)</span>
        <input data-testid={`${testid}-tracking`} value={f.tracking_code} maxLength={30} onChange={(e) => setF((s) => ({ ...s, tracking_code: e.target.value.toUpperCase() }))} placeholder="Ex: AA123456789BR" className={`${pInput} mono mt-1.5 tracking-wider`} />
      </label>
      <div className="flex flex-wrap gap-2 sm:col-span-2">
        <button type="submit" data-testid={`${testid}-submit`} disabled={!ok || busy} className="rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-black transition-transform hover:scale-[1.02] disabled:opacity-40">{busy ? "Salvando…" : submitLabel}</button>
        {onCancel && <button type="button" data-testid={`${testid}-cancel`} onClick={onCancel} className="rounded-full border border-white/15 px-5 py-2.5 text-sm font-semibold text-white hover:bg-white/10">Cancelar</button>}
      </div>
    </form>
  );
};
